import React from 'react';
import ItemCard, { type InventoryItem } from './ItemCard';

export interface InventoryPanelProps {
  items: InventoryItem[];
  onItemClick?: (item: InventoryItem) => void;
  onItemUse?: (item: InventoryItem) => void;
  className?: string;
}

const InventoryPanel: React.FC<InventoryPanelProps> = ({
  items,
  onItemClick,
  onItemUse,
  className = ''
}) => {

  return (
    <div className={`bg-transparent ${className}`} data-testid="inventory-panel">
      
      {/* Items List */}
      <div className="p-2" data-testid="inventory-items-container">
        {items.length === 0 ? (
          <div className="text-center py-8" data-testid="empty-inventory">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">No items</h3>
            <p className="mt-1 text-sm text-gray-500">Your inventory is empty.</p>
          </div>
        ) : (
          <div className="space-y-3" data-testid="inventory-items-list">
            {items.map((item) => (
              <ItemCard
                key={item.id}
                item={item}
                {...(onItemClick && { onItemClick })}
                {...(onItemUse && { onItemUse })}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryPanel;
